<mat-sidenav-container fxFlexFill>
	<mat-sidenav-content>
		<div class="navigation">
			<div class="navigation-title">{{ nav.title || selectedService }}</div>
			@if (nav) {
				<div class="navigation-item-container">
					@for (item of nav.overview; track item) {
						@if (!item.disabled) {
							@if (item.isExternal) {
								<a class="navigation-item" [href]="item.path" target="_blank">{{ item.displayName }}</a>
							} @else {
								<div class="navigation-item" [routerLink]="[item.path]" routerLinkActive="active">
									{{ item.displayName }}
								</div>
							}
							<mat-divider class="mb2"></mat-divider>
						}
					}
					@for (item of nav.sections; track item) {
						@if (!item.disabled) {
							<div class="navigation-header">{{ item.name }}</div>
							@for (resource of item.resources; track resource) {
								@if (!resource.disabled) {
									@if (resource.isExternal) {
										<a class="navigation-item" [href]="resource.path" target="_blank">{{ resource.displayName }}</a>
									} @else {
										<div class="navigation-item" [routerLink]="[resource.path]" routerLinkActive="active">
											{{ resource.displayName }}
										</div>
									}
								}
							}
							<mat-divider class="mb2"></mat-divider>
						}
					}
					@if (anchors.length > 0) {
						<div fxFlex></div>
						<div class="navigation-header">{{ 'app.menu.onThisPage' | translate }}</div>
						@for (anchor of anchors; track $index) {
							<div class="navigation-item navigation-anchor" (click)="scrollToAnchor(anchor)">
								{{ anchor.displayName }}
							</div>
						}
					}
				</div>
			}
		</div>

		<div class="content-wrapper" fxLayout="column">
			<router-outlet></router-outlet>
		</div>
	</mat-sidenav-content>

	<mat-sidenav position="end" mode="side" [opened]="helpOpen" [style]="{ minWidth: width, 'border-left': 'none' }">
		<div class="helpbox-container" fxFlex>
			<div class="helpbox-title" fxLayoutAlign="space-between center">
				<span>{{ title || 'Help' }}</span>
				<button mat-icon-button (click)="toggleHelp()"><mat-icon>close</mat-icon></button>
			</div>
			@if (templatePortal) {
				<cdk-virtual-scroll-viewport itemSize="50" fxFlex>
					<div fxLayout="column">
						<ng-container [cdkPortalOutlet]="templatePortal"></ng-container>
					</div>
				</cdk-virtual-scroll-viewport>
			} @else if (helpboxOverlay) {
				<cdk-virtual-scroll-viewport itemSize="50" fxFlex>
					<div fxLayout="column" [innerHtml]="helpboxOverlay.content"></div>
				</cdk-virtual-scroll-viewport>
			}
		</div>
	</mat-sidenav>
</mat-sidenav-container>
